import { render, staticRenderFns } from "./PromotionList.vue?vue&type=template&id=1309bf90&scoped=true"
import script from "./PromotionList.vue?vue&type=script&lang=ts"
export * from "./PromotionList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1309bf90",
  null
  
)

export default component.exports